import { SIZING_2 } from './sizings';

export const WEB_FONT_FORM_FIELD_INPUT = SIZING_2;
export const WEB_FONT_FORM_FIELD_LABEL = SIZING_2;
export const WEB_FONT_FORM_FIELD_ERROR = '0.875rem';
